import { __RouterContext } from 'react-router-dom';
import { useContext } from 'react';

const useLocation = () => {
  const { location } = useContext(__RouterContext);
  return location;
};

export default useLocation;
